import styled from "styled-components";

export const StyledImageContainer = styled.img`
  width: 100%;
  height: 100vh;
  position: absolute;
  max-height: 100%;
  object-fit: cover;
  z-index: -1;
`;

export const StyledHeroContainer = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
`;

export const StyledHeroGradient = styled.div`
  width: 100%;
  height: 100vh;
  z-index: 0;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0.2) 100%
  );
`;

export const StyledHeroTextContainer = styled.div`
  z-index: 1;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
`;

export const StyledHeroTitle = styled.h1`
  color: #ffffff;
  font-weight: bold;
  font-size: 3.5vw;

  @media (max-width: 1000px) {
    font-size: 5vw;
  }
  @media (max-width: 700px) {
    font-size: 7vw;
  }
`;

export const StyledVideoContainer = styled.video`
  width: 100%;
  height: 100vh;
  position: absolute;
  max-height: 100%;
  object-fit: cover;
  z-index: -1;
`;
